import type { GridProps } from '@chakra-ui/react'
import { forwardRef, Grid } from '@chakra-ui/react'

import type {
  CompletedOverviewItemProps} from './CompletedOverviewItem'
import {
  CompletedOverviewItem
} from './CompletedOverviewItem'

export interface CompletedOverviewProps extends GridProps {
  items?: CompletedOverviewItemProps[]
}

export const CompletedOverview = forwardRef(
  function CompletedOverview({ children, sx, items, ...rest }: CompletedOverviewProps, ref) {
    return (
      <Grid
        ref={ref}
        sx={{
          alignItems: 'start',
          pl: {
            base: 0,
            md: 12,
          },
          gap: 4,
          gridTemplateColumns: {
            base: '100%',
            md: '1fr 1fr',
            xl: 'auto auto auto',
          },
          ...sx,
        }}
        {...rest}
      >
        {items?.map((item, i) => {
          return <CompletedOverviewItem key={i} {...item} />
        })}
      </Grid>
    )
  },
)
